import React from 'react';
import type { Shipment } from '@xbcb/api-gateway-client';
import { ShipmentCommercialInvoiceDetailStatus } from '@xbcb/shipment-types';
import { AppRecordSecondaryHeaderContentProps } from 'routes';
import { getBadgeIcons } from 'components/AppRecordBadge';
import CargowiseIcon from 'components/CargowiseIcon';
import { getShipmentBadges } from 'libs/getRecordBadges';
import ShipmentStatus from 'components/ShipmentStatus';
import { StyledDiv } from './styles';

const ShipmentSecondaryHeader: React.FC<
  AppRecordSecondaryHeaderContentProps
> = ({ record }) => {
  const badgeIcons = getBadgeIcons(record, getShipmentBadges);
  const { externalIntegrationReferences = [], legs } = record as Shipment;

  return (
    <StyledDiv>
      <CargowiseIcon
        externalIntegrationReferences={externalIntegrationReferences}
      />
      {badgeIcons}
      <ShipmentStatus
        status={
          legs?.[0].commercialInvoiceDetail
            ?.status as ShipmentCommercialInvoiceDetailStatus
        }
      />
    </StyledDiv>
  );
};

export default ShipmentSecondaryHeader;
